import { Flex } from "antd";
import { Text } from "components/Text";
import { DeleteButton, StyledButton, StyledConfirmModal } from "./style";
import { DeleteModalProps } from "./types";
import spacing from "theme/spacing.module.scss";

export const ConfirmModal = ({
  isVisible,
  visibilityHandler,
  title,
  subtitle,
  onConfirm,
  onCancel,
  okText = "Usuń",
  cancelText = "Nie usuwaj",
  children
   }: DeleteModalProps) => {
  return (
    <StyledConfirmModal
      centered
      open={isVisible}
      onCancel={() => visibilityHandler(false)}
      getContainer={false}
      zIndex={2000}
      footer={[
        <StyledButton
          type="text"
          key="1"
          onClick={() => {
              visibilityHandler(false);
              if (onCancel) onCancel();
          }}
          size="large"
        >
          <Text $textVariant="pSMBold">{cancelText}</Text>
        </StyledButton>,
        <DeleteButton
          type="primary"
          key="2"
          onClick={() => {
            onConfirm();
            visibilityHandler(false);
          }}
        >
          <Text $textVariant="pSMBold">{okText}</Text>
        </DeleteButton>,
      ]}
    >
      <Flex vertical gap={spacing.spacingLG} justify="space-between">
        <Text $textVariant="pBold" $textColor="text500">
          {title}
        </Text>
        <Text $textVariant="pSM" $textColor="text500">
          {subtitle}
        </Text>
          {children}
      </Flex>
    </StyledConfirmModal>
  );
};
